export const Table = {
  variants: {
    admin: {
      table: {
        thead: {
          backgroundColor: 'brand.tableHeader',
          zIndex: 1,
        },
        th: {
          paddingY: 5,
          paddingX: 2,
          textTransform: 'none',
          color: 'white',
          fontSize: '14px',
          fontWeight: 'bold',
        },
        tr: {
          height: '50px',

          td: {
            fontSize: '14px',
            overflow: 'hidden',
            paddingY: 1,
            paddingX: 2,
          },
          '&:nth-of-type(even)': {
            td: {
              background: 'blackAlpha.50',
            },
          },
        },
      },
    },
    assignments: {
      table: {
        thead: {
          backgroundColor: 'neutral.0',
          borderBottom: '1px solid',
          borderBottomColor: 'neutral.100',
          position: 'sticky',
          top: -1,
          zIndex: 999,
          tr: {
            _hover: {
              backgroundColor: 'neutral.0',
            },
          },
        },
        th: {
          paddingY: 6,
          textTransform: 'none',
          fontSize: '14px',
          fontWeight: 500,
          color: 'baseBlack',
        },
        tr: {
          borderY: '1px solid',
          borderColor: 'neutral.100',
          fontSize: '14px',
          fontWeight: 500,
          color: 'neutral.900',
          _hover: {
            color: 'baseBlack',
            cursor: 'pointer',
            backgroundColor: '#F4F4F4',
          },
          '&[aria-disabled="true"]': {
            opacity: 0.4,
            _hover: {
              color: 'neutral.900',
              cursor: 'not-allowed',
            },
          },
          '&:nth-of-type(even)': {
            backgroundColor: 'neutral.0',
            _hover: {
              backgroundColor: '#F4F4F4',
            },
            '&[aria-disabled="true"]': {
              opacity: 0.4,
              _hover: {
                color: 'neutral.900',
                cursor: 'not-allowed',
              },
            },
          },
        },
        td: {
          '&:first-of-type': {
            color: 'baseBlack',
          },
        },
      },
    },
    sample: {
      table: {
        th: {
          paddingY: 5,
          paddingX: 2,
          textTransform: 'none',
          color: 'white',
          fontSize: '14px',
          fontWeight: 'bold',
        },
        tr: {
          height: '50px',

          td: {
            fontSize: '14px',
            overflow: 'hidden',
            fontWeight: 'medium',
            paddingY: 1,
            paddingX: 2,
          },
          '&:nth-of-type(even)': {
            td: {
              background: 'blackAlpha.50',
            },
          },
        },
      },
    },
  },
};
